export const authConstants = {
    AUTH_LOGIN_REQUEST: "AUTH_LOGIN_REQUEST",
    AUTH_LOGIN_COMPLETE: "AUTH_LOGIN_COMPLETE",
    AUTH_LOGOUT_REQUEST: "AUTH_LOGOUT_REQUEST",
    AUTH_LOGOUT_COMPLETE: "AUTH_LOGOUT_COMPLETE",

    AUTH_USER_PROFILE_DEATAILS_REQUEST: "AUTH_USER_PROFILE_DEATAILS_REQUEST",
    AUTH_USER_PROFILE_DEATAILS_COMPLETE: "AUTH_USER_PROFILE_DEATAILS_COMPLETE",

    AUTH_GET_REFRESH_TOKEN_REQUEST: "AUTH_GET_REFRESH_TOKEN_REQUEST",
    AUTH_GET_REFRESH_TOKEN_COMPLETE: "AUTH_GET_REFRESH_TOKEN_COMPLETE",

    PRE_REGISTRATION_REQUEST: "PRE_REGISTRATION_REQUEST",
    PRE_REGISTRATION_COMPLETE: "PRE_REGISTRATION_COMPLETE",

    PRE_REGISTRATION_ACTIVATE_REQUEST: "PRE_REGISTRATION_ACTIVATE_REQUEST",
    PRE_REGISTRATION_ACTIVATE_COMPLETE: "PRE_REGISTRATION_ACTIVATE_COMPLETE",

    FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST:
        "FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST",
    FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE:
        "FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE",

    FORGOT_PASSWORD_RESET_PASSWORD_REQUEST:
        "FORGOT_PASSWORD_RESET_PASSWORD_REQUEST",
    FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE:
        "FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE",

    SEND_OTP_REQUEST: "SEND_OTP_REQUEST",
    SEND_OTP_COMPLETE: "SEND_OTP_COMPLETE",

    RE_SEND_OTP_REQUEST: "RE_SEND_OTP_REQUEST",
    RE_SEND_OTP_COMPLETE: "RE_SEND_OTP_COMPLETE",

    AUTH_CHANGE_PASSWORD_PRE_AUTH_DETAILS:
        "AUTH_CHANGE_PASSWORD_PRE_AUTH_DETAILS",

    AUTH_CHANGE_PASSWORD_REQUEST: "AUTH_CHANGE_PASSWORD_REQUEST",
    AUTH_CHANGE_PASSWORD_COMPLETE: "AUTH_CHANGE_PASSWORD_COMPLETE",

    AUTH_SEND_OTP_AFTER_LOGIN_REQUEST: "AUTH_SEND_OTP_AFTER_LOGIN_REQUEST",
    AUTH_SEND_OTP_AFTER_LOGIN_COMPLETE: "AUTH_SEND_OTP_AFTER_LOGIN_COMPLETE",

    SEND_OTP_CHANGE_PASSWORD: "SEND_OTP_CHANGE_PASSWORD",
    CHANGE_PASSWORD: "CHANGE_PASSWORD",
    CHANGE_MOBILE_NUMBER: "CHANGE_MOBILE_NUMBER",
    SEND_OTP_CHANGE_MOBILE_NUMBER: "SEND_OTP_CHANGE_MOBILE_NUMBER",

    AUTH_CHANGE_PROFILE_PICTURE_REQUEST: "AUTH_CHANGE_PROFILE_PICTURE_REQUEST",
    AUTH_CHANGE_PROFILE_PICTURE_COMPLETE:
        "AUTH_CHANGE_PROFILE_PICTURE_COMPLETE",

    AUTH_CHANGE_NOTIFICATION_REQUEST: "AUTH_CHANGE_NOTIFICATION_REQUEST",
    AUTH_CHANGE_NOTIFICATION_COMPLETE: "AUTH_CHANGE_NOTIFICATION_COMPLETE",

    AUTH_CHANGE_MOBILE_NUMBER_REQUEST: "AUTH_CHANGE_MOBILE_NUMBER_REQUEST",
    AUTH_CHANGE_MOBILE_NUMBER_COMPLETE: "AUTH_CHANGE_MOBILE_NUMBER_COMPLETE",
    AUTH_CHANGE_MOBILE_NUMBER_PRE_MOBILE_DETAILS:
        "AUTH_CHANGE_MOBILE_NUMBER_PRE_MOBILE_DETAILS",

    AUTH_CHANGE_HOME_ADDRESS_REQUEST: "AUTH_CHANGE_HOME_ADDRESS_REQUEST",
    AUTH_CHANGE_HOME_ADDRESS_COMPLETE: "AUTH_CHANGE_HOME_ADDRESS_COMPLETE",

    AUTH_CHANGE_PROFILE_NAME_REQUEST: "AUTH_CHANGE_PROFILE_NAME_REQUEST",
    AUTH_CHANGE_PROFILE_NAME_COMPLETE: "AUTH_CHANGE_PROFILE_NAME_COMPLETE",

    AUTH_GET_USER_DETAILS_REQUEST: "AUTH_GET_USER_DETAILS_REQUEST",
    AUTH_GET_USER_DETAILS_COMPLETE: "AUTH_GET_USER_DETAILS_COMPLETE",

    AUTH_GET_PARTICIPANT_PROFILE_REQUEST:
        "AUTH_GET_PARTICIPANT_PROFILE_REQUEST",
    AUTH_GET_PARTICIPANT_PROFILE_COMPLETE:
        "AUTH_GET_PARTICIPANT_PROFILE_COMPLETE",

    AUTH_SUBSCRIBE_REQUEST: "AUTH_SUBSCRIBE_REQUEST",
    AUTH_SUBSCRIBE_COMPLETE: "AUTH_SUBSCRIBE_COMPLETE",

    AUTH_SELECT_DEALER_SHIP: "AUTH_SELECT_DEALER_SHIP",

    AUTH_USER_DEVICE_REQUEST: "AUTH_USER_DEVICE_REQUEST",
    AUTH_USER_DEVICE_COMPLETE: "AUTH_USER_DEVICE_COMPLETE",

    AUTH_VALIDATE_PARTICIPANT_BY_EMAIL_REQUEST: "AUTH_VALIDATE_PARTICIPANT_BY_EMAIL_REQUEST",
    AUTH_VALIDATE_PARTICIPANT_BY_EMAIL_COMPLETE: "AUTH_VALIDATE_PARTICIPANT_BY_EMAIL_COMPLETE",
    AUTH_VALIDATE_PARTICIPANT_BY_EMAIL_RESET: "AUTH_VALIDATE_PARTICIPANT_BY_EMAIL_RESET",
};

export const cookieConstants = {
    USER_DETAILS_COOKIE: "user",
    IS_LOGGED_IN: "is-logged-in",
    USER_NAME: "user_name",
};

export const otpTypeConstants = {
    AUTH_TYPE_LOGIN: 1,
    AUTH_TYPE_FOGOT_PASSWORD: 2,
    AUTH_TYPE_ACCOUNT_ACTIVATION: 4,
    AUTH_TYPE_CHANGE_PASSWORD: 5,
    AUTH_TYPE_CHANGE_MOBILE_NUMBER: 5,
    AUTH_TYPE_ADD_ACCOUNT: 5,
};

export const participantUrl = {
    EQUIPE_URL: process.env.EQUIPE_URL,
    RENAULT_TLC_URL: process.env.RENAULT_TLC_URL,
    RENAULT_REWARDS_URL: process.env.RENAULT_REWARDS_URL,
};

export const participantTypeIds = {
    PARTICIPANT: 13,
    TLC_PARTICIPANT: 14,
    RR_ROLE_ID: 15,
};

export const roleId = {
    RR_ROLE_ID: 15,
};

export const participantJobRoleIds = {
    PARTICIPANT_JOB_ROLE_ID_SERVICE_MANAGER: 15,
    PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR: 14,
    PARTICIPANT_JOB_ROLE_ID_SERVICE_AREA_MANAGER: 20,
    PARTICIPANT_JOB_ROLE_ID_TRADE_PARTS_MANAGER: 23,
    PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER: 24,
    PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER: 27,
    PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER: 28,
    PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE: 29,
    PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER: 30,
    TLC_PARTICIPANT_CUSTOMER: 21,
    TLC_PARTICIPANT_AREA_MANAGER: 22,
    TLC_TRADE_REP: 25,
    RR_JOB_ROLE_ID: 27,
    LCV_MANAGER: 31,
    RETAIL_SALES_EXECUTIVE: 32,
    RETAIL_SALES_ADMIN: 33,
    RETAIL_SALES_MANAGER: 34,
    RETAIL_SALES_ADHOC_WINNER: 35,
    PRO_PLUS_SALES_SPECIALIST: 36,
    PRO_PLUS_MANAGER: 37,
    FLEET_MANAGER: 38,
    GENERAL_MANAGER: 39,
    LCV_ADMIN:40,
    LCV_SUPER_ADMIN:41,
    LCV_AREA_MANAGER: 42,
    CX_SALES_ADVISOR: 43,
    CX_ALPINE_SALES_ADVISOR: 44,
    CX_DACIA_SALES_ADVISOR: 45,
    CX_PRO_PLUS_SALES_ADVISOR: 46,
    CX_VAN_SALES_SPECIALIST: 47,
    CX_FLEET_SALES_SPECIALIST: 48,
    CX_FLEET_SALES_MANAGER: 49,
    CX_FI_BUSINESS_MANAGER: 50,
    CX_AFTERSALES_MANAGER: 51,
    CX_MASTER_TECHNICIAN: 52,
    CX_CUSTOMER_SERVICE_APPRENTICE: 53,

};

// The retail sales roles use Equipe as a voucher shop and points bank only.
export const retailSalesJobRoleIds = [
    participantJobRoleIds.RETAIL_SALES_EXECUTIVE,
    participantJobRoleIds.RETAIL_SALES_ADMIN,
    participantJobRoleIds.RETAIL_SALES_MANAGER,
    // Adhoc Winner is a retail role on the backend too. Leaving it out of this list gave those
    // winners the full Equipe home page and the Campaigns menu.
    participantJobRoleIds.RETAIL_SALES_ADHOC_WINNER,
];

export const isRetailSalesJobRole = (jobRoleId) =>
    retailSalesJobRoleIds.includes(Number(jobRoleId));

// The CX award roles. They carry the job titles Renault writes on the winners file, and they exist
// so a winner can be given a role that matches what they do.
//
// Service Advisor is deliberately absent. It is a CX job title too, but it is an ordinary Equipe
// role held by hundreds of participants who have never won anything, and listing it here would take
// the campaigns and the rest of the portal away from all of them.
export const cxAwardJobRoleIds = [
    participantJobRoleIds.CX_SALES_ADVISOR,
    participantJobRoleIds.CX_ALPINE_SALES_ADVISOR,
    participantJobRoleIds.CX_DACIA_SALES_ADVISOR,
    participantJobRoleIds.CX_PRO_PLUS_SALES_ADVISOR,
    participantJobRoleIds.CX_VAN_SALES_SPECIALIST,
    participantJobRoleIds.CX_FLEET_SALES_SPECIALIST,
    participantJobRoleIds.CX_FLEET_SALES_MANAGER,
    participantJobRoleIds.CX_FI_BUSINESS_MANAGER,
    participantJobRoleIds.CX_AFTERSALES_MANAGER,
    participantJobRoleIds.CX_MASTER_TECHNICIAN,
    participantJobRoleIds.CX_CUSTOMER_SERVICE_APPRENTICE,
];

// Every role that uses Equipe as a voucher shop and points bank only, whichever incentive won them
// their points. A role missing from here gets the full Equipe home page and the Campaigns menu.
export const shopOnlyJobRoleIds = [
    ...retailSalesJobRoleIds,
    ...cxAwardJobRoleIds,
];

export const isShopOnlyJobRole = (jobRoleId) =>
    shopOnlyJobRoleIds.includes(Number(jobRoleId));

/** All LCV job roles  */
export const lcvJobRoleIds = [
    participantJobRoleIds.LCV_MANAGER,
    participantJobRoleIds.PRO_PLUS_SALES_SPECIALIST,
    participantJobRoleIds.PRO_PLUS_MANAGER,
    participantJobRoleIds.FLEET_MANAGER,
    participantJobRoleIds.GENERAL_MANAGER,
    participantJobRoleIds.LCV_ADMIN,
    participantJobRoleIds.LCV_SUPER_ADMIN,
    participantJobRoleIds.LCV_AREA_MANAGER,
];

export const isLcvJobRole = (jobRoleId) =>
    lcvJobRoleIds.includes(Number(jobRoleId));

/**
 * Roles that may reach the LCV campaign and its tracker. Wider than the list above because the
 * National Manager reads every campaign in the network, and the API already resolves him for the
 * dealership he selects. He is deliberately kept out of lcvJobRoleIds, which decides whether a user
 * IS the LCV audience and swaps the home page, news feed and campaign list to LCV in place of
 * Equipe.
 */
export const lcvAccessJobRoleIds = [
    ...lcvJobRoleIds,
    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER,
];

export const isLcvAccessJobRole = (jobRoleId) =>
    lcvAccessJobRoleIds.includes(Number(jobRoleId));

/** Can view game codes */
export const lcvTeamGameCodesJobRoleIds = [
    participantJobRoleIds.LCV_MANAGER,
    participantJobRoleIds.PRO_PLUS_MANAGER,
    participantJobRoleIds.FLEET_MANAGER,
    participantJobRoleIds.GENERAL_MANAGER,
    participantJobRoleIds.LCV_ADMIN,
    participantJobRoleIds.LCV_SUPER_ADMIN,
    participantJobRoleIds.LCV_AREA_MANAGER,
];

export const isLcvTeamGameCodesJobRole = (jobRoleId) =>
    lcvTeamGameCodesJobRoleIds.includes(Number(jobRoleId));

/** Can allocate / reset game codes  */
export const lcvTeamGameCodesAllocatorJobRoleIds = [
    participantJobRoleIds.GENERAL_MANAGER,
    participantJobRoleIds.FLEET_MANAGER,
    participantJobRoleIds.PRO_PLUS_MANAGER,
    participantJobRoleIds.LCV_MANAGER,
];

export const isLcvTeamGameCodesAllocatorJobRole = (jobRoleId) =>
    lcvTeamGameCodesAllocatorJobRoleIds.includes(Number(jobRoleId));

/** LCV managers  */
export const lcvManagersJobRoleIds = [
    participantJobRoleIds.GENERAL_MANAGER,
    participantJobRoleIds.FLEET_MANAGER,
    participantJobRoleIds.PRO_PLUS_MANAGER,
    participantJobRoleIds.LCV_MANAGER,
];

export const isLcvManagersJobRole = (jobRoleId) =>
    lcvManagersJobRoleIds.includes(Number(jobRoleId));

/** LCV non-managers  */
export const lcvAdminsJobRoleIds = [
    participantJobRoleIds.LCV_ADMIN,
    participantJobRoleIds.LCV_SUPER_ADMIN,
    participantJobRoleIds.LCV_AREA_MANAGER,
];

export const isLcvAdminsJobRole = (jobRoleId) =>
    lcvAdminsJobRoleIds.includes(Number(jobRoleId));